import { h } from 'preact';
import { SocialVideoCreative } from '../../common/creative/social';
import { InstagramFooter } from '../../common/creative/social/instagram-footer';
import { InstagramHeader } from '../../common/creative/social/instagram-header';

export interface IGVideoProps {
  videoSlot?: HTMLVideoElement;
}

export function InstagramVideo({ videoSlot }: IGVideoProps) {
  return <SocialVideoCreative videoSlot={videoSlot} header={<InstagramHeader />} footer={<InstagramFooter />} />;
}
